import { RootState } from "@/store/dtm";
import { progressType } from "@/types/progressType";
import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export interface progressState {
    progress: progressType
}

const initialState: progressState = {
    progress: {
        credentials: false,
        address: false,
        confirmProduct: false,
        finalizeAccount: false,
        mortgage: false,
        profile: false,
        coapplicant: false,
        propertyDetails: false,
        verifyIdentity: false,
        legal: false
    }
}

export const progressSlice = createSlice({
    name: "progress",
    initialState,
    reducers: {
        setCredentialsComplete: (state, action: PayloadAction<boolean>) => {
            const credentials = action.payload;
            state.progress.credentials = credentials;
        },
        setAddressComplete: (state, action: PayloadAction<boolean>) => {
            const address = action.payload;
            state.progress.address = address;
        },
        setConfirmProductComplete: (state, action: PayloadAction<boolean>) => {
            const confirmProduct = action.payload;
            state.progress.confirmProduct = confirmProduct;
        },
        setFinalizeAccoutComplete: (state, action: PayloadAction<boolean>) => {
            const finalizeAccount = action.payload;
            state.progress.finalizeAccount = finalizeAccount;
        },
        setMortgageComplete: (state, action: PayloadAction<boolean>) => {
            const mortgage = action.payload;
            state.progress.mortgage = mortgage;
        },
        setProfileComplete: (state, action: PayloadAction<boolean>) => {
            const profile = action.payload;
            state.progress.profile = profile;
        },
        setCoapplicantComplete: (state, action: PayloadAction<boolean>) => {
            const coapplicant = action.payload;
            state.progress.coapplicant = coapplicant;
        },
        setHomeDetailsComplete: (state, action: PayloadAction<boolean>) => {
            const homeDetails = action.payload;
            state.progress.propertyDetails = homeDetails;
        },
        setVerifyIdentityComplete: (state, action: PayloadAction<boolean>) => {
            const verify = action.payload;
            state.progress.verifyIdentity = verify;
        },
        setLegalComplete: (state, action: PayloadAction<boolean>) => {
            const complete = action.payload;
            state.progress.legal = complete;
        },

        clearProgressState: (state) => {
            state.progress.credentials = false;
            state.progress.address = false;
            state.progress.confirmProduct = false;
            state.progress.finalizeAccount = false;
            state.progress.mortgage = false;
            state.progress.profile = false;
            state.progress.coapplicant = false;
            state.progress.propertyDetails = false;
            state.progress.verifyIdentity = false;
            state.progress.legal = false;
        }
    }
});

export const { setCredentialsComplete, setAddressComplete, setConfirmProductComplete, setFinalizeAccoutComplete, setMortgageComplete, 
                setCoapplicantComplete, setProfileComplete, setHomeDetailsComplete, setVerifyIdentityComplete, setLegalComplete, clearProgressState } = progressSlice.actions

export const selectProgress = (state: RootState) => state.credential;

export default progressSlice.reducer

